import { render, staticRenderFns } from "./LeadListView.vue?vue&type=template&id=c9674660&scoped=true&"
import script from "./LeadListView.vue?vue&type=script&lang=js&"
export * from "./LeadListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9674660",
  null
  
)

export default component.exports